import React, { useCallback, useState } from 'react';
import * as PropTypes from 'prop-types';
import styles from './DetailsModal.module.scss';
import Button from 'components/Button/Button';
import { ReactComponent as InfoIcon } from 'images/ic-info-outline.svg';
import Modal from 'components/Modal/Modal';

export function DetailsModal(props) {
  const { actionDesc = '-', mobActionDesc = '-', deferredObligations = '-' } = props;
  const [modalView, setModalView] = useState(false);

  const hideModal = useCallback(() => {
    setModalView(false);
  });
  const showModal = useCallback(() => {
    setModalView(true);
  });

  return (
    <>
      <Button
        type={'button'}
        extraClassName={styles.link}
        hasWrapper={false}
        isLinkStyled
        onClick={showModal}
      >
        <span className={styles.icon}>
          <InfoIcon />
        </span>
      </Button>
      <Modal
        className={'boo'}
        type={'medium'}
        color={'white'}
        showModal={modalView}
        onClose={hideModal}
      >
        <h2 className={'H2 '}>Детали по мере поддержки</h2>

        <h3 className={'H3 mt-4 mb-2'}>Документ, по которому предоставлена мера:</h3>
        <span className={'text-black-l-30'}>{actionDesc || '-'}</span>

        <h3 className={'H3 mt-4 mb-2'}>Применяемая мера:</h3>
        <span className={'text-black-l-30'}>{mobActionDesc || '-'}</span>

        <h3 className={'H3 mt-4 mb-2'}>Информация о новых сроках и суммах:</h3>
        <span className={'text-black-l-30'} style={{ 'white-space': 'pre-wrap' }}>
          {deferredObligations?.replaceAll('//', '\n') || '-'}
        </span>
      </Modal>
    </>
  );
}

DetailsModal.propTypes = {
  actionDesc: PropTypes.string,
  mobActionDesc: PropTypes.string,
  deferredObligations: PropTypes.string,
};
